import React from 'react';
import { Upload } from 'antd';

const { Dragger } = Upload;

const CustomDragger = props => {
  const { children, ...otherProps } = props;
  return <Dragger {...otherProps}>{children}</Dragger>;
};

export default CustomDragger;
